module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_27.e78ca6ab.png";